// extracted by mini-css-extract-plugin
export default {"calendarModuleSVG":"ePvTj","calendarModuleSVGPastFuture":"BXcAM","svgIcon":"ihPm6","selected":"EWFIh","svgIconLight":"g6hHJ","svgText":"LSLVv"};